import React, { useEffect } from 'react';
import {
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import InputController from 'components/Form/InputController';
import { BrandFilter, ModalType } from 'constants/common';
import { toast } from 'components/Toast';
import { BookmarkerFormValidate } from 'utils/validation';
import { yupResolver } from '@hookform/resolvers/yup';
import SelectController from 'components/Form/SelectController';
import { useCreateBookmarkerMutation } from 'services/user';
import isEmpty from 'lodash/isEmpty';

const CreateBookMarkerModal = ({ isOpen, categorysDetail, onClose, refetch }) => {
  const cancelRef = React.useRef();
  const createBookmarkerMutation = useCreateBookmarkerMutation();
  const { control, handleSubmit, reset, setValue } = useForm({
    resolver: yupResolver(BookmarkerFormValidate),
    defaultValues: {
      bookMaker: undefined,
      homepage: '',
    },
  });

  useEffect(() => {
    if (categorysDetail) {
      reset({
        bookMaker: BrandFilter.find(item => item.value === categorysDetail.bookMarker),
        depositPage: categorysDetail.depositPage,
        homepage: categorysDetail.homepage,
        id: categorysDetail?._id,
      });
    }
  }, [categorysDetail]);

  const handleSuccess = () => {
    toast.showMessageSuccess(`${categorysDetail ? 'Cập nhật' : 'Tạo'} hệ thống thành công`);
    refetch?.();
    onClose(ModalType.Add);
  };
  const handleError = error => {
    toast.showMessageError(
      error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || `${categorysDetail ? 'Cập nhật' : 'Tạo'} hệ thống thành công`
    );
  };
  const onSubmit = async values => {
    const payload = {
      homepage: values.homepage,
      bookMarker: values.bookMaker.value
    }
    if(isEmpty(categorysDetail)) {
      createBookmarkerMutation.mutate(
        payload,
        {
          onSuccess: () => handleSuccess(),
          onError: error => handleError(error),
        }
      );
      return;
    }
    createBookmarkerMutation.mutate(
      payload,
      {
        onSuccess: () => handleSuccess(),
        onError: error => handleError(error),
      }
    );
  };
  return (
    <>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={() => {
          onClose(ModalType.Add);
        }}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />
        <AlertDialogContent maxW={'600px'}>
          <AlertDialogHeader textTransform="uppercase">{categorysDetail ? 'Cập nhật' : 'Tạo'} hệ thống</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            <SelectController
              styleContainer={{
                marginBottom: '1rem',
              }}
              control={control}
              name="bookMaker"
              label="Tên"
              isRequired
              options={BrandFilter}
              isDisabled={categorysDetail?.bookMarker ? true : false}
            />
            <InputController
              styleContainer={{
                marginBottom: '1rem',
              }}
              control={control}
              name="homepage"
              isRequired
              label="Trang chủ"
            />
            {/* <InputController
              styleContainer={{
                marginBottom: '1rem',
              }}
              control={control}
              name="depositPage"
              label="Trang nạp tiền"
            /> */}
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={() => {
                onClose(ModalType.Add);
              }}
            >
              Hủy
            </Button>
            <Button
              colorScheme="blue"
              ml={3}
              isLoading={createBookmarkerMutation.isPending}
              onClick={handleSubmit(onSubmit)}
            >
              {categorysDetail ? 'Cập nhập' : 'Tạo'}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default CreateBookMarkerModal;
